import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React from 'react';

const DIRECTIONS: { [key: string]: string } = {
  top: 'top',
  bottom: 'bottom',
  left: 'left',
  right: 'right',
};

const ROTATE = {
  [DIRECTIONS.left]: 'rotate(90deg)',
  [DIRECTIONS.top]: 'rotate(180deg)',
  [DIRECTIONS.right]: 'rotate(270deg)',
  [DIRECTIONS.bottom]: 'rotate(0deg)',
};

const BlueArrow = ({ direction, className, ...restProps }: any) => {
  const selectedDirection = DIRECTIONS[direction] || DIRECTIONS.bottom;
  const classes = makeStyles({
    blueArrow: {
      transform: ROTATE[selectedDirection],
    },
  })();
  return (
    <svg
      width="11"
      height="7"
      viewBox="0 0 11 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx(className, classes.blueArrow)}
      {...restProps}
    >
      <path d="M0.708984 1.5L5.42327 5.5L9.70898 1.5" stroke="#00AEEF" strokeWidth="2" />
    </svg>
  );
};

export default BlueArrow;
